"use client"

import type { ReactNode } from "react"

interface InfoItemProps {
  icon: ReactNode
  label: string
  value: string
}

export function InfoItem({ icon, label, value }: InfoItemProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="text-indigo-600 flex-shrink-0">{icon}</div>
      <div>
        <p className="text-sm text-slate-600 font-medium">{label}</p>
        <p className="font-semibold text-slate-900">{value}</p>
      </div>
    </div>
  )
}
